import React from 'react'
import { FormGroup, Col, Input, InputGroup, InputGroupAddon, Button, } from 'reactstrap'
import statesInitials from '../../helpers/statesInitials'

/*
  <DistrictsFilter 
    districtNameSearch={districtNameSearch}
    districtStateFilter={districtStateFilter}
    setFilter={setFilter}
    setSearch={setSearch}
  />
*/

export default function DistrictsFilter({districtNameSearch, districtStateFilter, setFilter, setSearch}) {
  let options = [
    <option value='' key='statePlaceholder'>State</option>
  ]
  statesInitials.forEach((state) => {
    options.push(
      <option value={state} key={`stateOption${state}`}>{state}</option>
    )
  })
  

  return (
    <FormGroup row>
      <Col xs='12' sm='8' md='9' lg='10'>
        <InputGroup>
            <InputGroupAddon addonType='prepend'>
              <Button color='primary'><i className="fa fa-search"></i> Search</Button>
            </InputGroupAddon>
          <Input
            type='text'
            placeholder='Search by name...'
            value={districtNameSearch}
            onChange={(e) => setSearch('districtNameSearch', e)}
          />
        </InputGroup>
      </Col>
      <Col xs='12' sm='4' md='3' lg='2'>
        <Input
          type='select'
          value={districtStateFilter}
          onChange={(e) => setFilter('districtState', e.target.value)}
        >
          {options}
        </Input>
      </Col>
    </FormGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/DistrictsFilter.js